import ConfigurationService from "../../ConfigurationService";

export default class NavigationService {
  static getNextViewName(currentView) {
    const path = ConfigurationService.getViewsPath();
    let currentViewIndex = path.findIndex(step => step[currentView] !== undefined);

    if (currentViewIndex >= (path.length - 1)) {
      return currentView;
    }

    const nextViewObject = path[currentViewIndex + 1];

    return ConfigurationService.getViewName(nextViewObject);
  }

  static getPreviousViewName(currentView) {
    const path = ConfigurationService.getViewsPath();
    let currentViewIndex = path.findIndex(step => step[currentView] !== undefined);

    if (currentViewIndex <= 0) {
      return currentView;
    }

    const previousViewObject = path[currentViewIndex - 1];

    return ConfigurationService.getViewName(previousViewObject);
  }

  static getFirstView() {
    const firstViewObject = ConfigurationService.getViewsPath()[0];

    return ConfigurationService.getViewName(firstViewObject);
  }
};
